var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesAuthoritiesDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#C0C2C6",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_26782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7222 13.7778V21.7778H22.2778V26.2222H14.2778V13.7778H26.7222ZM26.7222 12H14.2778C13.3 12 12.5 12.8 12.5 13.7778V26.2222C12.5 27.2 13.3 28 14.2778 28H23.1667L28.5 22.6667V13.7778C28.5 12.8 27.7 12 26.7222 12ZM20.5 21.7778H16.0556V20H20.5V21.7778ZM24.9444 18.2222H16.0556V16.4444H24.9444V18.2222Z",
    fill: "#C0C2C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_26782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesAuthoritiesDisabledIcon);
export default __webpack_public_path__ + "static/media/rolesAuthorities-disabledIcon.33c272b923b4900387140c7900e7ca91.svg";
export { ForwardRef as ReactComponent };